function roundMoney(val) {
  return Number((Math.round(Number(val) * 100) / 100).toFixed(2));
}
function percentage(total, percent) {
  return ((percent / 100) * total).toFixed(2);
}

export const calcProfit = (data, setData, isEditMode) => {
  const {
    valueOfEachHour,
    timeYouSpend,
    serviceProviders,
    listingPrice,
    listingFee,
    transactionFee,
    creditCardFee,
    isEdit,
    serviceFee,
    otherFee,
    activity,
    materials,
  } = data;
  let valueOfTime = 0;
  if (valueOfEachHour) {
    if (timeYouSpend.value) {
      const numlabType = timeYouSpend.time === "hours" ? 1 : 60;
      valueOfTime = (+valueOfEachHour * +timeYouSpend.value) / +numlabType;
    } else {
      activity.map((ac) => {
        const numlabTypeAc = ac.time === "hours" ? 1 : 60;
        valueOfTime += (+valueOfEachHour * +ac.value) / +numlabTypeAc;
      });
    }
  }

  // init dat astore
  const etsyData = { ...data };
  const poshmarkData = { ...data };
  const depopData = { ...data };
  const shopifyData = { ...data };
  const StockXData = { ...data };
  const goatData = { ...data };
  const mercariData = { ...data };
  const socialData = { ...data };
  const vintedData = { ...data };
  const offerUpData = { ...data };
  const grailed = { ...data };

  //Etsy service providers
  if (!isEdit) {
    etsyData.listingFee = 0.2;
    etsyData.transactionFee = (
      0.065 *
      (+etsyData.listingPrice + +etsyData.shipping)
    ).toFixed(2);
    etsyData.creditCardFee = 0;
  }
  etsyData.profit = +(
    +etsyData.listingPrice -
    +etsyData.listingFee -
    +etsyData.transactionFee -
    +etsyData.materials -
    +etsyData.shipping -
    +etsyData.creditCardFee -
    +valueOfTime
  ).toFixed(2);
  if (serviceProviders === "Etsy") {
    if (!isEdit) {
      data.listingFee = etsyData.listingFee;
      data.transactionFee = etsyData.transactionFee;
      data.creditCardFee = etsyData.creditCardFee;
    }
    data.profit = etsyData.profit;
  }

  // Poshmark service providers
  if (!isEdit) {
    poshmarkData.shipping = "0";
    if (+poshmarkData.listingPrice < 15) {
      poshmarkData.commissionFee = 2.95;
    } else {
      poshmarkData.commissionFee = (0.2 * +poshmarkData.listingPrice).toFixed(
        2,
      );
    }
  }

  poshmarkData.profit = +(
    +poshmarkData.listingPrice -
    +poshmarkData.commissionFee -
    +poshmarkData.materials -
    +poshmarkData.shipping -
    +valueOfTime
  ).toFixed(2);
  if (serviceProviders === "Poshmark") {
    if (!isEdit) {
      data.commissionFee = poshmarkData.commissionFee;
    }
    data.shipping = poshmarkData.shipping;
    data.profit = poshmarkData.profit;
  }

  // Depop service providers
  if (!isEdit) {
    depopData.depopFee = percentage(+depopData.listingPrice, 10);
    depopData.transactionFee = +(
      +percentage(+depopData.listingPrice, 3.3) + 0.45
    ).toFixed(2);
    depopData.depopShippingLabelFee = "7.6";
  }
  if (!+depopData.depopShippingLabelFee) {
    depopData.creditCardFee = (
      +percentage(+depopData.listingPrice, 3.49) + 0.49
    ).toFixed(2);
  } else {
    depopData.creditCardFee = 0;
  }
  depopData.profit = +(
    +depopData.listingPrice -
    +depopData.depopFee -
    +depopData.depopShippingLabelFee -
    +depopData.transactionFee -
    +depopData.materials -
    +valueOfTime
  ).toFixed(2);
  if (serviceProviders === "Depop") {
    if (!isEdit) {
      data.depopFee = depopData.depopFee;
      data.transactionFee = depopData.transactionFee;
      data.depopShippingLabelFee = depopData.depopShippingLabelFee;
    }
    if (!+data.depopShippingLabelFee) {
      data.creditCardFee = depopData.creditCardFee;
    } else {
      data.creditCardFee = 0;
    }
    data.profit = depopData.profit;
  }

  // Shopify service providers
  if (!isEdit) {
    shopifyData.creditCardFee = (
      +percentage(+shopifyData.listingPrice, 2.9) + 0.3
    ).toFixed(2);
  }
  shopifyData.profit = +(
    +shopifyData.listingPrice -
    +shopifyData.creditCardFee -
    +shopifyData.shipping -
    +shopifyData.materials -
    +valueOfTime
  ).toFixed(2);
  if (serviceProviders === "Shopify") {
    if (!isEdit) {
      data.creditCardFee = shopifyData.creditCardFee;
    }
    data.profit = shopifyData.profit;
  }

  // StockX service providers
  if (!isEdit) {
    StockXData.shipping = "4.00";
    if (StockXData.stockLevel === "Level 1" || !StockXData.stockLevel) {
      StockXData.transactionFee = percentage(+StockXData.listingPrice, 9);
    }
    if (StockXData.stockLevel === "Level 2") {
      StockXData.transactionFee = percentage(+StockXData.listingPrice, 8.5);
    }
    if (StockXData.stockLevel === "Level 3") {
      StockXData.transactionFee = percentage(+StockXData.listingPrice, 8.0);
    }
    if (StockXData.stockLevel === "Level 4") {
      StockXData.transactionFee = percentage(+StockXData.listingPrice, 7.5);
    }
    if (StockXData.stockLevel === "Level 5") {
      StockXData.transactionFee = percentage(+StockXData.listingPrice, 7.0);
    }
  }
  StockXData.profit = +(
    +StockXData.listingPrice -
    +StockXData.transactionFee -
    +StockXData.materials -
    +StockXData.shipping -
    +valueOfTime
  ).toFixed(2);
  if (serviceProviders === "StockX") {
    if (!isEdit) {
      data.transactionFee = StockXData.transactionFee;
    }
    data.shipping = StockXData.shipping;
    data.profit = StockXData.profit;
  }

  // GOAT service providers
  if (!isEdit) {
    if (goatData.goatLevel === "90-100" || !goatData.goatLevel) {
      goatData.transactionFee = (
        +percentage(+goatData.listingPrice, 9.5) + 5
      ).toFixed(2);
    }
    if (goatData.goatLevel === "70-89") {
      goatData.transactionFee = (
        +percentage(+goatData.listingPrice, 15) + 5
      ).toFixed(2);
    }
    if (goatData.goatLevel === "50-69") {
      goatData.transactionFee = (
        +percentage(+goatData.listingPrice, 20) + 5
      ).toFixed(2);
    }
    goatData.creditCardFee = percentage(+goatData.listingPrice, 2.9);
    goatData.shipping = "0";
  }
  goatData.profit = +(
    +goatData.listingPrice -
    +goatData.transactionFee -
    +goatData.creditCardFee -
    +goatData.materials -
    +goatData.shipping -
    +valueOfTime
  ).toFixed(2);
  if (serviceProviders === "GOAT") {
    if (!isEdit) {
      data.transactionFee = goatData.transactionFee;
      data.creditCardFee = goatData.creditCardFee;
      data.shipping = "0";
    }
    data.profit = goatData.profit;
  }

  // Mercari service providers
  if (!isEdit) {
    mercariData.paymentProcessing = +(
      +percentage(+mercariData.listingPrice, 2.9) + 0.5
    ).toFixed(2);
    mercariData.listingFee = 0;
    mercariData.selling = +(+percentage(
      +mercariData.listingPrice,
      2.9,
    )).toFixed(2);
  }
  mercariData.profit = +(
    +mercariData.listingPrice -
    +mercariData.shipping -
    +mercariData.paymentProcessing -
    +mercariData.selling -
    +mercariData.listingFee -
    +mercariData.materials -
    +valueOfTime
  ).toFixed(2);
  if (serviceProviders === "Mercari") {
    if (!isEdit) {
      data.paymentProcessing = mercariData.paymentProcessing;
      data.listingFee = mercariData.listingFee;
      data.selling = mercariData.selling;
    }
    data.profit = mercariData.profit;
  }

  // Grailed service providers
  if (!isEdit) {
    grailed.paymentProcessing = +(
      +percentage(+grailed.listingPrice, 4.99) + 0.49
    ).toFixed(2);
    grailed.listingFee = 0;
    grailed.selling = +(+percentage(+grailed.listingPrice, 4.99)).toFixed(2);
  }
  grailed.profit = +(
    +grailed.listingPrice -
    +grailed.shipping -
    +grailed.paymentProcessing -
    +grailed.selling -
    +grailed.listingFee -
    +valueOfTime
  ).toFixed(2);
  if (serviceProviders === "Grailed") {
    if (!isEdit) {
      data.paymentProcessing = grailed.paymentProcessing;
      data.listingFee = grailed.listingFee;
      data.selling = grailed.selling;
    }
    data.profit = grailed.profit;
  }

  // Instagram/Facebook Marketplace service providers
  socialData.profit = +(
    +socialData.listingPrice -
    +socialData.shipping -
    +socialData.materials -
    +valueOfTime
  ).toFixed(2);
  if (serviceProviders === "Instagram/Facebook Marketplace") {
    data.profit = socialData.profit;
  }

  // Vinted service providers
  if (!isEdit) {
    vintedData.transactionFee = +(+percentage(
      +vintedData.listingPrice,
      0.7,
    )).toFixed(2);
  }
  vintedData.profit = +(
    +vintedData.listingPrice -
    +vintedData.materials -
    +vintedData.transactionFee -
    +valueOfTime
  ).toFixed(2);
  if (serviceProviders === "Vinted") {
    if (!isEdit) {
      data.transactionFee = vintedData.transactionFee;
    }
    data.profit = vintedData.profit;
  }

  // OfferUp Marketplace service providers
  if (!isEdit) {
    const serviceCharge = +(+percentage(
      +offerUpData.listingPrice,
      12.9,
    )).toFixed(2);
    offerUpData.serviceFee = serviceCharge < 1.99 ? 1.99 : serviceCharge;
  }
  offerUpData.profit = +(
    +offerUpData.listingPrice -
    +offerUpData.shipping -
    +offerUpData.materials -
    +offerUpData.serviceFee -
    +valueOfTime
  ).toFixed(2);
  if (serviceProviders === "OfferUp") {
    data.serviceFee = offerUpData.serviceFee;
    data.profit = offerUpData.profit;
  }

  if (serviceProviders === "Custom") {
    data.profit = +(
      +listingPrice -
      +listingFee -
      +transactionFee -
      +creditCardFee -
      +serviceFee -
      +otherFee -
      +materials -
      +valueOfTime
    ).toFixed(2);
  }

  const allData = [
    { name: "etsy", profit: etsyData.profit },
    { name: "poshmark", profit: poshmarkData.profit },
    { name: "depop", profit: depopData.profit },
    { name: "shopify", profit: shopifyData.profit },
    { name: "StockX", profit: StockXData.profit },
    { name: "goat", profit: goatData.profit },
    { name: "instagram/facebook marketplace", profit: socialData.profit },
    { name: "mercari", profit: mercariData.profit },
    { name: "vinted", profit: vintedData.profit },
    { name: "Grailed", profit: grailed.profit },
  ];

  const sortArray = allData
    .filter((d) => d.name !== serviceProviders.toLowerCase())
    .sort((a, b) => (a.profit < b.profit ? 1 : b.profit < a.profit ? -1 : 0));

  setData({
    ...data,
    topThreeVal: sortArray?.slice(0, 3),
  });
};

export const calcListing = (data, setData, isEditMode) => {
  const {
    valueOfEachHour,
    timeYouSpend,
    serviceProviders,
    stockLevel,
    profit,
    transactionFee,
    creditCardFee,
    isEdit,
    serviceFee,
    otherFee,
    activity,
    materials,
  } = data;
  let valueOfTime = 0;
  if (valueOfEachHour) {
    if (timeYouSpend.value) {
      const numlabType = timeYouSpend.time === "hours" ? 1 : 60;
      valueOfTime = (+valueOfEachHour * +timeYouSpend.value) / +numlabType;
    } else {
      activity.map((ac) => {
        const numlabTypeAc = ac.time === "hours" ? 1 : 60;
        valueOfTime += (+valueOfEachHour * +ac.value) / +numlabTypeAc;
      });
    }
  }
  // init dat astore
  const etsyData = { ...data };
  const poshmarkData = { ...data };
  const depopData = { ...data };
  const shopifyData = { ...data };
  const StockXData = { ...data };
  const goatData = { ...data };
  const mercariData = { ...data };
  const socialData = { ...data };
  const vintedData = { ...data };
  const offerUpData = { ...data };
  const otherData = { ...data };

  //Etsy service providers
  if (!isEdit) {
    etsyData.listingFee = 0.2;
    etsyData.listingPrice = (
      (+etsyData.profit +
        +etsyData.materials +
        +valueOfTime +
        0.2 +
        0.065 * +etsyData.shipping) /
      0.935
    ).toFixed(2);
    etsyData.transactionFee = (
      0.065 *
      (+etsyData.listingPrice + +etsyData.shipping)
    ).toFixed(2);
    etsyData.creditCardFee = 0;
  }
  etsyData.profit =
    +etsyData.listingPrice - (etsyData.materials + etsyData.lcost);
  if (serviceProviders === "Etsy") {
    if (!isEdit) {
      data.transactionFee = etsyData.transactionFee;
      data.creditCardFee = etsyData.creditCardFee;
      data.listingFee = etsyData.listingFee;
    }
    data.listingPrice = etsyData.listingPrice;
  }

  //poshmarkData service providers.
  poshmarkData.listingPrice = (
    +etsyData.profit +
    +etsyData.materials +
    (2.95 * +etsyData.shipping) / 0.8
  ).toFixed(2);
  poshmarkData.listingFee = 0.2;
  poshmarkData.transactionFee = (
    0.065 *
    (+poshmarkData.listingPrice + +poshmarkData.shipping)
  ).toFixed(2);
  poshmarkData.creditCardFee = 0;
  if (serviceProviders === "Poshmark") {
    if (!isEdit) {
      data.transactionFee = poshmarkData.transactionFee;
      data.creditCardFee = poshmarkData.creditCardFee;
    }
    data.listingPrice = poshmarkData.listingPrice;
  }

  //Depop service providers
  if (!isEdit) {
    depopData.listingPrice = (
      (+depopData.profit +
        +depopData.materials +
        +valueOfTime +
        0.1 +
        0.035 * +depopData.shipping +
        0.49) /
      0.965
    ).toFixed(2);
    depopData.listingFee = 0.1;
    depopData.transactionFee = (
      0.035 * (+depopData.listingPrice + +depopData.shipping) +
      0.49
    ).toFixed(2);
    depopData.creditCardFee = 0;
    depopData.depopFee = percentage(+depopData.listingPrice, 10);
  }
  if (serviceProviders === "Depop") {
    if (!isEdit) {
      data.transactionFee = depopData.transactionFee;
      data.creditCardFee = depopData.creditCardFee;
      data.listingFee = depopData.listingFee;
    }
    data.listingPrice = (+depopData.listingPrice + +depopData.depopFee).toFixed(
      2,
    );
    data.depopFee = depopData.depopFee;
  }

  //Shopify service providers
  if (!isEdit) {
    shopifyData.transactionFee = (
      0.035 * (+shopifyData.listingPrice + +shopifyData.shipping) +
      0.49
    ).toFixed(2);
  }
  shopifyData.listingPrice = (
    (+shopifyData.profit +
      +shopifyData.materials +
      +valueOfTime +
      0.29 * +shopifyData.shipping +
      0.3) /
    0.971
  ).toFixed(2);
  if (serviceProviders === "Shopify") {
    data.creditCardFee =
      0.29 * (+shopifyData.listingPrice + +shopifyData.shipping) + 0.3;
    data.listingPrice = (
      +shopifyData.listingPrice + +shopifyData.creditCardFee
    ).toFixed(2);
  }

  //StockX service providers ***
  if (StockXData.stockLevel === "Level 1" || !StockXData.stockLevel) {
    const listingLevel1 =
      (+shopifyData.profit +
        +shopifyData.materials +
        +valueOfTime +
        0.1 +
        0.03 * +shopifyData.shipping) /
        0.97 || 0;
    StockXData.listingPrice = +listingLevel1.toFixed(2);
    // StockXData.transactionFee = (
    //   0.1 +
    //   0.03 * (+StockXData.listingPrice + +StockXData.shipping)
    // ).toFixed(2);
    StockXData.transactionFee = percentage(+StockXData.listingPrice, 10);
    StockXData.listingPrice += +StockXData.transactionFee;
  }
  if (StockXData.stockLevel === "Level 2") {
    const listingLevel2 =
      (+shopifyData.profit +
        +shopifyData.materials +
        +valueOfTime +
        0.95 +
        0.03 * +shopifyData.shipping) /
        0.97 || 0;
    StockXData.listingPrice = +listingLevel2.toFixed(2);
    // StockXData.transactionFee = (
    //   0.95 +
    //   0.03 * (+StockXData.listingPrice + +StockXData.shipping)
    // ).toFixed(2);
    StockXData.transactionFee = percentage(+StockXData.listingPrice, 9.5);
    StockXData.listingPrice += +StockXData.transactionFee;
  }
  if (StockXData.stockLevel === "Level 3") {
    const listingLevel3 =
      (+shopifyData.profit +
        +shopifyData.materials +
        +valueOfTime +
        0.9 +
        0.03 * +shopifyData.shipping) /
        0.97 || 0;
    StockXData.listingPrice = +listingLevel3.toFixed(2);
    // StockXData.transactionFee = (
    //   0.9 +
    //   0.03 * (+StockXData.listingPrice + +StockXData.shipping)
    // ).toFixed(2);
    StockXData.transactionFee = percentage(+StockXData.listingPrice, 9.0);
    StockXData.listingPrice += +StockXData.transactionFee;
  }
  if (StockXData.stockLevel === "Level 4") {
    const listingLevel4 =
      (+shopifyData.profit +
        +shopifyData.materials +
        +valueOfTime +
        0.85 +
        0.03 * +shopifyData.shipping) /
        0.97 || 0;
    StockXData.listingPrice = +listingLevel4.toFixed(2);
    // StockXData.transactionFee = (
    //   0.85 +
    //   0.03 * (+StockXData.listingPrice + +StockXData.shipping)
    // ).toFixed(2);
    StockXData.transactionFee = percentage(+StockXData.listingPrice, 8.5);
    StockXData.listingPrice += +StockXData.transactionFee;
  }

  if (StockXData.stockLevel === "Level 5") {
    const listingLevel5 =
      (+shopifyData.profit +
        +shopifyData.materials +
        +valueOfTime +
        0.8 +
        0.03 * +shopifyData.shipping) /
        0.97 || 0;
    StockXData.listingPrice = +listingLevel5.toFixed(2);
    StockXData.transactionFee = percentage(+StockXData.listingPrice, 8.0);
    StockXData.listingPrice += +StockXData.transactionFee;
  }
  const paymentProcessing = percentage(+StockXData.listingPrice, 3.0);
  StockXData.transactionFee = +StockXData.transactionFee + +paymentProcessing;
  StockXData.listingPrice = +StockXData.listingPrice - +paymentProcessing;
  if (serviceProviders === "StockX") {
    if (!isEdit) {
      data.transactionFee = StockXData.transactionFee;
    }
    data.listingPrice = StockXData.listingPrice;
  }

  //GOAT service providers
  goatData.listingPrice = (
    (+goatData.profit +
      +goatData.materials +
      +valueOfTime +
      0.095 +
      0.029 * +goatData.shipping +
      5) /
      0.971 || 0
  ).toFixed(2);
  if (!isEdit) {
    if (goatData.goatLevel === "90-100" || !goatData.goatLevel) {
      goatData.transactionFee = (
        +percentage(+goatData.listingPrice, 9.5) + 5
      ).toFixed(2);
    }
    if (goatData.goatLevel === "70-89") {
      goatData.transactionFee = (
        +percentage(+goatData.listingPrice, 15) + 5
      ).toFixed(2);
    }
    if (goatData.goatLevel === "50-69") {
      goatData.transactionFee = (
        +percentage(+goatData.listingPrice, 20) + 5
      ).toFixed(2);
    }
    goatData.creditCardFee = percentage(+goatData.listingPrice, 2.9);
    goatData.shipping = "0";
    goatData.listingPrice = (
      +goatData.transactionFee +
      +goatData.creditCardFee +
      +goatData.listingPrice
    ).toFixed(2);
  }

  if (serviceProviders === "GOAT") {
    if (!isEdit) {
      data.transactionFee = goatData.transactionFee;
      data.creditCardFee = goatData.creditCardFee;
      data.shipping = goatData.shipping;
    }
    data.listingPrice = goatData.listingPrice;
  }

  //Other service providers

  if (serviceProviders === "Custom") {
    data.listingPrice = +(
      +profit +
      +transactionFee +
      +creditCardFee +
      +serviceFee +
      +otherFee +
      +materials +
      +valueOfTime
    ).toFixed(2);
  }

  setData({
    ...data,
  });
};

export const calcHourly = (data, setData, isEditMode) => {
  const {
    valueOfEachHour,
    timeYouSpend,
    serviceProviders,
    stockLevel,
    listingFee,
    transactionFee,
    creditCardFee,
    isEdit,
    serviceFee,
    otherFee,
    activity,
  } = data;

  const etsyData = { ...data };
  const poshmarkData = { ...data };
  const depopData = { ...data };
  const shopifyData = { ...data };
  const StockXData = { ...data };
  const goatData = { ...data };
  const mercariData = { ...data };
  const socialData = { ...data };
  const vintedData = { ...data };
  const offerUpData = { ...data };

  //Etsy service providers
  const costVal = (
    0.971 * +etsyData.listingPrice -
    +etsyData.materials -
    +etsyData.profit -
    0.29 * +etsyData.shipping -
    0.3
  ).toFixed(2);
  if (!isEdit) {
    etsyData.listingFee = 0.2;
    etsyData.transactionFee = (
      0.065 *
      (+etsyData.listingPrice + +etsyData.shipping)
    ).toFixed(2);
  }
  if (serviceProviders === "Etsy") {
    if (!isEdit) {
      data.listingFee = etsyData.listingFee;
      data.transactionFee = etsyData.transactionFee;
    }
    // @ts-ignore
    data.lcost = +costVal / +timeYouSpend.value;
  }

  //Poshmark service providers
  poshmarkData.commissionFee = (0.2 * +poshmarkData.listingPrice).toFixed(2);
  if (poshmarkData.commissionFee <= 15) {
    etsyData.lcost = (
      0.8 * +etsyData.listingPrice -
      +etsyData.materials -
      +etsyData.profit
    ).toFixed(2);
  } else {
    etsyData.lcost = (
      +etsyData.listingPrice -
      +etsyData.materials -
      +etsyData.profit -
      2.95
    ).toFixed(2);
  }
  // if (!isEdit) {
  //   poshmarkData.listingFee = 0.2;
  //   poshmarkData.transactionFee = (
  //     0.065 *
  //     (+poshmarkData.listingPrice + +poshmarkData.shipping)
  //   ).toFixed(2);
  // }
  if (serviceProviders === "Poshmark") {
    if (!isEdit) {
      data.listingFee = poshmarkData.listingFee;
      data.commissionFee = poshmarkData.commissionFee;
    }
    data.lcost = +poshmarkData.lcost / +timeYouSpend.value;
  }

  //Depop service providers
  depopData.lcost = (
    0.965 * +depopData.listingPrice -
    +depopData.materials -
    +depopData.profit -
    0.1 -
    0.065 * +depopData.shipping -
    0.49
  ).toFixed(2);
  if (!isEdit) {
    depopData.listingFee = 0.1;
    depopData.depopFee = (
      0.35 * (+depopData.listingPrice + +depopData.shipping) +
      0.49
    ).toFixed(2);
  }
  if (serviceProviders === "Depop") {
    if (!isEdit) {
      data.listingFee = depopData.listingFee;
      data.depopFee = depopData.depopFee;
    }
    data.lcost = +depopData.lcost / +timeYouSpend.value;
  }

  //Shopify  service providers
  shopifyData.lcost = (
    0.971 * +shopifyData.listingPrice -
    +shopifyData.materials -
    +shopifyData.profit -
    0.29 * +shopifyData.shipping -
    0.3
  ).toFixed(2);
  if (!isEdit) {
    shopifyData.creditCardFee =
      0.29 * (+shopifyData.listingPrice - +shopifyData.shipping) + 0.3;
  }
  if (serviceProviders === "Shopify") {
    if (!isEdit) {
      data.creditCardFee = shopifyData.creditCardFee;
    }
    data.lcost = +shopifyData.lcost / +timeYouSpend.value;
  }

  //StockX  service providers**************************
  if (StockXData.stockLevel === "Level 1" || !StockXData.stockLevel) {
    shopifyData.lcost = (
      0.97 * +shopifyData.listingPrice -
      +shopifyData.materials -
      +shopifyData.profit -
      0.1 -
      0.03 * +shopifyData.shipping
    ).toFixed(2);
    if (!isEdit) {
      shopifyData.transactionFee =
        0.1 + 0.3 * (+shopifyData.listingPrice - +shopifyData.shipping);
    }
  }
  if (StockXData.stockLevel === "Level 2") {
    shopifyData.lcost = (
      0.97 * +shopifyData.listingPrice -
      +shopifyData.materials -
      +shopifyData.profit -
      0.095 -
      0.03 * +shopifyData.shipping
    ).toFixed(2);
    if (!isEdit) {
      shopifyData.transactionFee =
        0.95 + 0.3 * (+shopifyData.listingPrice - +shopifyData.shipping);
    }
  }
  if (StockXData.stockLevel === "Level 3") {
    shopifyData.lcost = (
      0.97 * +shopifyData.listingPrice -
      +shopifyData.materials -
      +shopifyData.profit -
      0.09 -
      0.003 * +shopifyData.shipping
    ).toFixed(2);
    if (!isEdit) {
      shopifyData.transactionFee =
        0.09 + 0.3 * (+shopifyData.listingPrice - +shopifyData.shipping);
    }
  }
  if (StockXData.stockLevel === "Level 4") {
    shopifyData.lcost = (
      0.97 * +shopifyData.listingPrice -
      +shopifyData.materials -
      +shopifyData.profit -
      0.85 -
      0.03 * +shopifyData.shipping
    ).toFixed(2);
    if (!isEdit) {
      shopifyData.transactionFee =
        0.85 + 0.3 * (+shopifyData.listingPrice - +shopifyData.shipping);
    }
  }
  if (StockXData.stockLevel === "Level 5") {
    shopifyData.lcost = (
      0.97 * +shopifyData.listingPrice -
      +shopifyData.materials -
      +shopifyData.profit -
      0.08 -
      0.03 * +shopifyData.shipping
    ).toFixed(2);
    if (!isEdit) {
      shopifyData.transactionFee =
        0.08 + 0.3 * (+shopifyData.listingPrice - +shopifyData.shipping);
    }
  }
  if (serviceProviders === "StockX") {
    if (!isEdit) {
      data.transactionFee = shopifyData.transactionFee;
    }
    data.lcost = +shopifyData.lcost / +timeYouSpend.value;
  }

  //Goat  service providers
  goatData.lcost = (
    0.971 * +goatData.listingPrice -
    +goatData.materials -
    +goatData.profit -
    0.95 -
    0.29 * +goatData.shipping -
    5
  ).toFixed(2);
  if (!isEdit) {
    goatData.transactionFee = 0.95;
    goatData.creditCardFee =
      0.29 * (+goatData.listingPrice - +goatData.shipping) + 0.3;
  }
  if (serviceProviders === "Costs") {
    if (!isEdit) {
      data.transactionFee = goatData.transactionFee;
      data.creditCardFee = goatData.creditCardFee;
    }
    data.lcost = +goatData.lcost / +timeYouSpend.value;
  }

  if (setData) setData({ ...data });
  return data;
};

function convertH2M(timeInHour) {
  const timeParts = timeInHour.split(":");
  return Number(timeParts[0]) * 60 + Number(timeParts[1]);
}

export const averagePerHour = (data, setData, isReturn) => {
  const { timeYouSpend, serviceProviders, isEdit } = data;

  // init dat astore
  const etsyData = { ...data };
  const poshmarkData = { ...data };
  const depopData = { ...data };
  const shopifyData = { ...data };
  const StockXData = { ...data };
  const goatData = { ...data };
  const mercariData = { ...data };
  const socialData = { ...data };
  const vintedData = { ...data };
  const offerUpData = { ...data };

  //Etsy service providers
  if (!isEdit) {
    etsyData.listingFee = 0.2;
    etsyData.transactionFee = (
      0.065 *
      (+etsyData.listingPrice + +etsyData.shipping)
    ).toFixed(2);
  }
  etsyData.averagePerHour = (
    (+etsyData.listingPrice -
      (+etsyData.materials +
        0.065 * (+etsyData.listingPrice + +etsyData.shipping) +
        0.2)) /
    +timeYouSpend.value
  ).toFixed(2);
  if (serviceProviders === "Etsy") {
    if (!isEdit) {
      data.listingFee = etsyData.listingFee;
      data.transactionFee = etsyData.transactionFee;
    }
    data.averagePerHour = etsyData.averagePerHour;
  }

  //poshmarkData service providers
  if (!isEdit) {
    if (poshmarkData.materials > 15) {
      data.listingFee = 2.95;
    } else {
      data.listingFee = 0.2 * poshmarkData.listingPrice;
    }
  }
  poshmarkData.averagePerHour = (
    (+poshmarkData.listingPrice -
      (+poshmarkData.materials +
        0.2 * (+poshmarkData.listingPrice + +poshmarkData.shipping))) /
    +timeYouSpend.value
  ).toFixed(2);
  if (serviceProviders === "Poshmark") {
    if (!isEdit) {
      data.listingFee = poshmarkData.listingFee;
    }
    data.averagePerHour = poshmarkData.averagePerHour;
  }

  //depopData service providers
  if (!isEdit) {
    depopData.listingFee = 0.2;
    depopData.transactionFee =
      0.35 * (depopData.listingPrice + depopData.shipping) + 0.49;
  }
  depopData.averagePerHour = (
    (+depopData.listingPrice -
      (+depopData.materials +
        0.1 +
        0.35 * (+depopData.listingPrice + +depopData.shipping) +
        0.49)) /
    +timeYouSpend.value
  ).toFixed(2);
  if (serviceProviders === "Depop") {
    if (!isEdit) {
      data.listingFee = depopData.listingFee;
      data.transactionFee = depopData.transactionFee;
    }
    data.averagePerHour = depopData.averagePerHour;
  }

  //shopifyData service providers
  if (!isEdit) {
    shopifyData.creditCardFee =
      0.29 * (shopifyData.listingPrice + shopifyData.shipping) + 0.3;
  }
  shopifyData.averagePerHour = (
    (+shopifyData.listingPrice -
      (+shopifyData.materials +
        0.29 * (+shopifyData.listingPrice + +shopifyData.shipping) +
        0.3)) /
    +timeYouSpend.value
  ).toFixed(2);
  if (serviceProviders === "Shopify") {
    if (!isEdit) {
      data.creditCardFee = shopifyData.creditCardFee;
    }
    data.averagePerHour = shopifyData.averagePerHour;
  }

  // StockX service providers
  if (!isEdit) {
    StockXData.shipping = "4.00";
    if (StockXData.stockLevel === "Level 1" || !StockXData.stockLevel) {
      StockXData.transactionFee = 0.1;
      StockXData.paymentProcessing =
        0.03 * (shopifyData.listingPrice + shopifyData.shipping);
      StockXData.averagePerHour = (
        (+shopifyData.listingPrice -
          (+shopifyData.materials +
            0.1 +
            0.03 * (+shopifyData.listingPrice + +shopifyData.shipping))) /
        +timeYouSpend.value
      ).toFixed(2);
    }
    if (StockXData.stockLevel === "Level 2") {
      StockXData.transactionFee = 0.095;
      StockXData.paymentProcessing =
        0.03 * (shopifyData.listingPrice + shopifyData.shipping);
      StockXData.averagePerHour = (
        (+shopifyData.listingPrice -
          (+shopifyData.materials +
            0.95 +
            0.03 * (+shopifyData.listingPrice + +shopifyData.shipping))) /
        +timeYouSpend.value
      ).toFixed(2);
    }
    if (StockXData.stockLevel === "Level 3") {
      StockXData.transactionFee = 0.09;
      StockXData.paymentProcessing =
        0.03 * (shopifyData.listingPrice + shopifyData.shipping);
      StockXData.averagePerHour = (
        (+shopifyData.listingPrice -
          (+shopifyData.materials +
            0.9 +
            0.03 * (+shopifyData.listingPrice + +shopifyData.shipping))) /
        +timeYouSpend.value
      ).toFixed(2);
    }
    if (StockXData.stockLevel === "Level 4") {
      StockXData.transactionFee = 0.85;
      StockXData.paymentProcessing =
        0.03 * (shopifyData.listingPrice + shopifyData.shipping);
      StockXData.averagePerHour = (
        (+shopifyData.listingPrice -
          (+shopifyData.materials +
            0.1 +
            0.03 * (+shopifyData.listingPrice + +shopifyData.shipping))) /
        +timeYouSpend.value
      ).toFixed(2);
    }
    if (StockXData.stockLevel === "Level 5") {
      StockXData.transactionFee = 0.08;
      StockXData.paymentProcessing =
        0.03 * (shopifyData.listingPrice + shopifyData.shipping);
      StockXData.averagePerHour = (
        (+shopifyData.listingPrice -
          (+shopifyData.materials +
            0.08 +
            0.03 * (+shopifyData.listingPrice + +shopifyData.shipping))) /
        +timeYouSpend.value
      ).toFixed(2);
    }
  }

  if (serviceProviders === "StockX") {
    if (!isEdit) {
      data.transactionFee = StockXData.transactionFee;
      data.paymentProcessing = StockXData.paymentProcessing;
    }
    data.averagePerHour = StockXData.averagePerHour;
  }

  //goatData service providers
  if (!isEdit) {
    if (goatData.goatLevel === "90-100" || !goatData.goatLevel) {
      goatData.averagePerHour = (
        (+goatData.listingPrice -
          +goatData.materials -
          0.095 * +goatData.listingPrice -
          5 -
          0.58) /
        +timeYouSpend.value
      ).toFixed(2);
    }
    if (goatData.goatLevel === "70-89") {
      goatData.averagePerHour = (
        (+goatData.listingPrice -
          +goatData.materials -
          0.15 * +goatData.listingPrice -
          5 -
          0.58) /
        +timeYouSpend.value
      ).toFixed(2);
    }
    if (goatData.goatLevel === "50-69") {
      goatData.averagePerHour = (
        (+goatData.listingPrice -
          +goatData.materials -
          0.2 * +goatData.listingPrice -
          5 -
          0.58) /
        +timeYouSpend.value
      ).toFixed(2);
    }
  }

  if (serviceProviders === "GOAT") {
    data.averagePerHour = goatData.averagePerHour;
  }

  //vintedData service providers
  if (!isEdit) {
    vintedData.materials = vintedData.materials + vintedData.shipping;
    vintedData.commissionFee = 0.5 * vintedData.listingPrice + 0.07;
  }
  vintedData.averagePerHour = (
    (+vintedData.listingPrice -
      (+vintedData.materials +
        0.7 +
        0.05 * (+vintedData.listingPrice + +vintedData.shipping))) /
    +timeYouSpend.value
  ).toFixed(2);
  if (serviceProviders === "Vinted") {
    if (!isEdit) {
      data.materials = vintedData.materials;
      data.commissionFee = vintedData.commissionFee;
    }
    data.averagePerHour = vintedData.averagePerHour;
  }

  //offerUpData service providers
  if (!isEdit) {
    offerUpData.commissionFee = offerUpData.listingPrice + 0.129;
  }
  offerUpData.averagePerHour = (
    (+offerUpData.listingPrice -
      (+offerUpData.materials + 0.129 * +offerUpData.listingPrice)) /
    +timeYouSpend.value
  ).toFixed(2);
  if (serviceProviders === "OfferUp") {
    if (!isEdit) {
      data.commissionFee = offerUpData.commissionFee;
    }
    data.averagePerHour = offerUpData.averagePerHour;
  }

  // Mercari service providers
  if (!isEdit) {
    mercariData.commissionFee = 0.5 * mercariData.listingPrice + 0.07;
  }
  mercariData.averagePerHour = (
    (+mercariData.listingPrice -
      +mercariData.materials -
      (0.029 * +mercariData.listingPrice - 0.5)) /
    +timeYouSpend.value
  ).toFixed(2);
  if (serviceProviders === "Mercari") {
    if (!isEdit) {
      data.commissionFee = mercariData.commissionFee;
    }
    data.averagePerHour = mercariData.averagePerHour;
  }

  //Other service providers
  if (serviceProviders === "Custom") {
    data.averagePerHour = +(
      +mercariData.listingPrice - +mercariData.materials
    ).toFixed(2);
  }

  // Instagram/Facebook Marketplace service providers
  if (serviceProviders === "Instagram/Facebook Marketplace") {
    data.averagePerHour = +(
      +mercariData.listingPrice - +mercariData.materials
    ).toFixed(2);
  }
  if (!setData) return { ...data };
  setData({
    ...data,
  });
  if (isReturn) return data;
};

function getDecimalPart(num) {
  if (Number.isInteger(num)) {
    return 0;
  }
  const decimalStr = num.toString().split(".")[1];
  return Number(decimalStr);
}

export const profitMargin = (data, setData, isReturn) => {
  const { serviceProviders, isEdit } = data;

  const etsyData = { ...data };
  const poshmarkData = { ...data };
  const depopData = { ...data };
  const shopifyData = { ...data };
  const StockXData = { ...data };
  const goatData = { ...data };
  const mercariData = { ...data };
  const socialData = { ...data };
  const vintedData = { ...data };
  const offerUpData = { ...data };
  const otherData = { ...data };

  //Etsy service providers
  etsyData.netProfit = (
    +etsyData.listingPrice -
    (+etsyData.materials + 0.65 * +etsyData.listingPrice + 0.2)
  ).toFixed(2);
  etsyData.netProfitMargin = (
    100 *
    (etsyData.netProfit / +etsyData.listingPrice)
  ).toFixed(2);
  if (serviceProviders === "Etsy") {
    // @ts-ignore
    data.netProfit = +etsyData.netProfit;
    data.netProfitMargin = +etsyData.netProfitMargin;
  }

  //poshmarkData service providers
  poshmarkData.netProfit = (
    +poshmarkData.listingPrice -
    (+poshmarkData.materials + 0.2 * +poshmarkData.listingPrice)
  ).toFixed(2);
  poshmarkData.netProfitMargin = (
    poshmarkData.netProfit / +poshmarkData.listingPrice
  ).toFixed(2);
  if (serviceProviders === "Poshmark") {
    // @ts-ignore
    data.netProfit = +poshmarkData.netProfit;
    data.netProfitMargin = +poshmarkData.netProfitMargin;
  }

  //depopData service providers
  depopData.netProfit = (
    +depopData.listingPrice -
    (+depopData.materials + 0.1 + 0.035 * +depopData.listingPrice + 0.49)
  ).toFixed(2);
  depopData.netProfitMargin = (
    depopData.netProfit / +depopData.listingPrice
  ).toFixed(2);
  if (serviceProviders === "Depop") {
    // @ts-ignore
    data.netProfit = +depopData.netProfit;
    data.netProfitMargin = +depopData.netProfitMargin;
  }

  //shopifyData service providers
  shopifyData.netProfit = (
    +shopifyData.listingPrice -
    (+shopifyData.materials + 0.29 * +shopifyData.listingPrice + 0.3)
  ).toFixed(2);
  shopifyData.netProfitMargin = (
    shopifyData.netProfit / +shopifyData.listingPrice
  ).toFixed(2);
  if (serviceProviders === "Shopify") {
    // @ts-ignore
    data.netProfit = +shopifyData.netProfit;
    data.netProfitMargin = +shopifyData.netProfitMargin;
  }

  // StockX service providers
  if (!isEdit) {
    if (StockXData.stockLevel === "Level 1" || !StockXData.stockLevel) {
      shopifyData.netProfit = (
        +shopifyData.listingPrice -
        (+shopifyData.materials + 0.1 + 0.03 * +shopifyData.listingPrice)
      ).toFixed(2);
      shopifyData.netProfitMargin = (
        shopifyData.netProfit / +shopifyData.listingPrice
      ).toFixed(2);
    }
    if (StockXData.stockLevel === "Level 2") {
      shopifyData.netProfit = (
        +shopifyData.listingPrice -
        (+shopifyData.materials + 0.95 + 0.03 * +shopifyData.listingPrice)
      ).toFixed(2);
      shopifyData.netProfitMargin = (
        shopifyData.netProfit / +shopifyData.listingPrice
      ).toFixed(2);
    }
    if (StockXData.stockLevel === "Level 3") {
      shopifyData.netProfit = (
        +shopifyData.listingPrice -
        (+shopifyData.materials + 0.09 + 0.03 * +shopifyData.listingPrice)
      ).toFixed(2);
      shopifyData.netProfitMargin = (
        shopifyData.netProfit / +shopifyData.listingPrice
      ).toFixed(2);
    }
    if (StockXData.stockLevel === "Level 4") {
      shopifyData.netProfit = (
        +shopifyData.listingPrice -
        (+shopifyData.materials + 0.85 + 0.03 * +shopifyData.listingPrice)
      ).toFixed(2);
      shopifyData.netProfitMargin = (
        shopifyData.netProfit / +shopifyData.listingPrice
      ).toFixed(2);
    }
    if (StockXData.stockLevel === "Level 5") {
      shopifyData.netProfit = (
        +shopifyData.listingPrice -
        (+shopifyData.materials + 0.08 + 0.03 * +shopifyData.listingPrice)
      ).toFixed(2);
      shopifyData.netProfitMargin = (
        shopifyData.netProfit / +shopifyData.listingPrice
      ).toFixed(2);
    }
  }
  if (serviceProviders === "StockX") {
    data.netProfit = +shopifyData.netProfit;
    data.netProfitMargin = +shopifyData.netProfitMargin;
  }

  //goatData service providers
  if (goatData.goatLevel === "90-100") {
    goatData.netProfit =
      +goatData.listingPrice -
      (+goatData.materials + 0.095 * +goatData.listingPrice + 5);
  }
  if (goatData.goatLevel === "70-89") {
    goatData.netProfit =
      +goatData.listingPrice -
      (+goatData.materials + 0.15 * +goatData.listingPrice + 5);
  }
  if (goatData.goatLevel === "50-69") {
    goatData.netProfit =
      +goatData.listingPrice -
      (+goatData.materials + 0.2 * +goatData.listingPrice + 5);
  }

  goatData.netProfitMargin = (
    100 *
    (goatData.netProfit / +goatData.listingPrice)
  ).toFixed(2);
  if (serviceProviders === "GOAT") {
    data.netProfit = (+goatData.netProfit).toFixed(2);
    data.netProfitMargin = +goatData.netProfitMargin;
  }

  //vintedData service providers
  vintedData.netProfit =
    +vintedData.listingPrice -
    (+vintedData.materials + 0.05 * +vintedData.listingPrice + 0.7);
  vintedData.netProfitMargin = (
    100 *
    (vintedData.netProfit / +vintedData.listingPrice)
  ).toFixed(2);
  if (serviceProviders === "Vinted") {
    data.netProfit = +vintedData.netProfit;
    data.netProfitMargin = +vintedData.netProfitMargin;
  }

  //offerUpData service providers
  if (offerUpData.listingPrice >= "15.43") {
    offerUpData.netProfit =
      +offerUpData.listingPrice -
      (+offerUpData.materials + 0.129 * +offerUpData.listingPrice);
  } else {
    offerUpData.netProfit =
      +offerUpData.listingPrice - (+offerUpData.materials + 1.99);
  }

  offerUpData.netProfitMargin = (
    100 *
    (offerUpData.netProfit / +offerUpData.listingPrice)
  ).toFixed(2);
  if (serviceProviders === "OfferUp") {
    data.netProfit = (+offerUpData.netProfit).toFixed(2);
    data.netProfitMargin = +offerUpData.netProfitMargin;
  }

  //mercariData service providers
  mercariData.netProfit =
    +mercariData.listingPrice -
    (+mercariData.materials + 0.129 * +mercariData.listingPrice + 0.5);
  mercariData.netProfitMargin = (
    100 *
    (mercariData.netProfit / +mercariData.listingPrice)
  ).toFixed(2);
  if (serviceProviders === "Mercari") {
    data.netProfit = +mercariData.netProfit;
    data.netProfitMargin = +mercariData.netProfitMargin;
  }

  //socialData service providers
  socialData.netProfit = +socialData.listingPrice - +socialData.materials;
  socialData.netProfitMargin = (
    100 *
    (socialData.netProfit / +socialData.listingPrice)
  ).toFixed(2);
  if (serviceProviders === "Instagram/Facebook Marketplace") {
    data.netProfit = +socialData.netProfit;
    data.netProfitMargin = +socialData.netProfitMargin;
  }

  //otherData service providers
  otherData.netProfit = +otherData.listingPrice - +otherData.materials;
  otherData.netProfitMargin = (
    100 *
    (otherData.netProfit / +otherData.listingPrice)
  ).toFixed(2);
  if (serviceProviders === "Instagram/Facebook Marketplace") {
    data.netProfit = +otherData.netProfit;
    data.netProfitMargin = +otherData.netProfitMargin;
  }

  if (!setData) return { ...data };
  setData({
    ...data,
  });
  if (isReturn) return data;
};
